<div class="contact-page" #contactRoot>
  <section class="contact-hero dingo-section section-first">
    <div class="container">
      <div class="contact-hero-grid">
        <div class="contact-hero-copy">
          <div class="section-head contact-reveal reveal-on-scroll" data-reveal="section-head" data-reveal-trigger="immediate">
            <p class="contact-kicker">Diagnóstico y contacto</p>
            <h1 class="contact-title">
              Cuéntanos dónde quieres crecer.
              <span class="highlight-green">Nosotros trazamos la ruta.</span>
            </h1>
            <p class="contact-desc">
              Comparte tu reto comercial, digital o tecnológico. Revisamos tu contexto y te proponemos el siguiente paso
              con claridad, enfoque y velocidad.
            </p>
          </div>
        </div>

        <figure class="dingo-hero-image-stage contact-reveal" data-reveal="media" data-reveal-trigger="immediate" style="--reveal-order: 2">
          <div class="dingo-hero-image-stack">
            <img class="img-fluid dingo-cutout-edge-fix" src="assets/images/contact/contact.png" alt="Diagnóstico y contacto con Grupo DINGO" />
          </div>
        </figure>
      </div>
    </div>
  </section>

  <section class="contact-workspace dingo-section dingo-bg-accent">
    <div class="container">
      <div class="contact-layout">
        <aside class="contact-info-panel contact-reveal" data-reveal="card">
          <p class="contact-kicker">Información</p>
          <h2>Hablemos con <span class="highlight-green">datos, intención y siguiente paso</span></h2>
          <p>
            Completa el formulario y nuestro equipo revisará tu solicitud para darte una primera recomendación de ruta.
          </p>

          <div class="contact-methods">
            <a class="contact-method" href="tel:+5215616635041">
              <i class="bi bi-telephone-fill"></i>
              <span>
                <small>Teléfono</small>
                +52 1 56 1663 5041
              </span>
            </a>
            <a class="contact-method" href="mailto:contacto@grupodingo.com.mx">
              <i class="bi bi-envelope-at-fill"></i>
              <span>
                <small>Email</small>
                contacto&#64;grupodingo.com.mx
              </span>
            </a>
            <div class="contact-method">
              <i class="bi bi-geo-alt-fill"></i>
              <span>
                <small>Ubicación</small>
                Adolfo Prieto 1145 Interior 3, Col. Del Valle Centro, Benito Juárez, CDMX.
              </span>
            </div>
          </div>

          <div class="contact-next-card">
            <h3>Qué pasa después</h3>
            <ul>
              <li><i class="bi bi-check-circle-fill"></i> Analizamos tu mensaje y tu objetivo principal.</li>
              <li><i class="bi bi-check-circle-fill"></i> Te sugerimos servicio, alcance y prioridad inicial.</li>
              <li><i class="bi bi-check-circle-fill"></i> Te contactamos por correo o llamada, según convenga.</li>
            </ul>
          </div>

          <div class="contact-social">
            <a href="https://www.facebook.com/profile.php?id=100063605347598" class="contact-social-icon" aria-label="Facebook">
              <i class="bi bi-facebook"></i>
            </a>
            <a href="https://www.instagram.com/dingomarketing_?igsh=MWY0cXRzNTM1dHNraA%3D%3D&utm_source=qr" class="contact-social-icon" aria-label="Instagram">
              <i class="bi bi-instagram"></i>
            </a>
            <a href="https://wa.me/5215543581515" class="contact-social-icon" aria-label="WhatsApp">
              <i class="bi bi-whatsapp"></i>
            </a>
          </div>
        </aside>

        <form #contactFormRef class="contact-form-panel contact-reveal" id="contact-form" (ngSubmit)="onSubmit()" data-reveal="media" style="--reveal-order: 1">
          <div class="contact-form-head">
            <p class="contact-kicker">Brief inicial</p>
            <h2>Envíanos <span class="highlight-green">un mensaje</span></h2>
          </div>

          @if (isInCooldown()) {
          <div class="alert contact-cooldown-alert">
            Ya enviaste un mensaje. Por favor, inténtalo de nuevo más tarde.
          </div>
          }
          @if (errorMessage) {
          <div class="alert contact-error-alert">{{ errorMessage }}</div>
          }

          <div class="contact-field">
            <label for="nombre">Nombre <span>*</span></label>
            <input type="text" id="nombre" name="nombre" [(ngModel)]="nombre" placeholder="Tu nombre completo" [disabled]="sending">
          </div>

          <div class="contact-field-grid">
            <div class="contact-field">
              <label for="email">Correo electrónico <span>*</span></label>
              <input type="email" id="email" name="email" [(ngModel)]="email" placeholder="correo@ejemplo.com" [disabled]="sending">
            </div>
            <div class="contact-field">
              <label for="telefono">Teléfono <span>*</span></label>
              <input type="tel" id="telefono" name="telefono" [(ngModel)]="telefono" placeholder="+52 55 1234 5678" [disabled]="sending">
            </div>
          </div>

          <div class="contact-field-grid">
            <div class="contact-field">
              <label for="empresa">Empresa</label>
              <input type="text" id="empresa" name="empresa" [(ngModel)]="empresa" placeholder="Nombre de tu empresa" [disabled]="sending">
            </div>
            <div class="contact-field">
              <label for="servicio">Servicio de interés</label>
              <select id="servicio" name="servicio" [(ngModel)]="servicio" [disabled]="sending">
                <option value="">Selecciona una opción</option>
                <option value="Marketing Digital">Marketing Digital</option>
                <option value="Desarrollo de Apps">Desarrollo de Apps</option>
                <option value="Publicidad">Publicidad</option>
                <option value="Data Science">Data Science</option>
                <option value="Otro">Otro</option>
              </select>
            </div>
          </div>

          <div class="contact-field">
            <label for="mensaje">Tu mensaje <span>*</span></label>
            <textarea id="mensaje" name="mensaje" rows="5" [(ngModel)]="mensaje" placeholder="Cuéntanos en qué podemos ayudarte..." [disabled]="sending"></textarea>
          </div>

          <div class="contact-privacy">
            <input type="checkbox" id="privacidad" name="privacidad" [(ngModel)]="aceptoPrivacidad" [disabled]="sending">
            <label for="privacidad">
              Acepto que mis datos sean utilizados únicamente para contactarme y atender mi solicitud.
            </label>
          </div>
          @if (submitted && !aceptoPrivacidad) {
          <small class="contact-validation">Debes aceptar el uso de tus datos para enviar el formulario.</small>
          }

          @if (shouldShowHCaptcha) {
          <div class="contact-field">
            <label>Verificación hCaptcha <span>*</span></label>
            <div class="captcha-wrapper">
              <div class="h-captcha" data-captcha="true" data-theme="dark"></div>
            </div>
          </div>
          }

          <button type="submit" class="contact-submit-btn" [disabled]="sending || !isFormValid()">
            <span>{{ sending ? 'Enviando...' : 'Enviar mensaje' }}</span>
            <i class="bi bi-arrow-up-right"></i>
          </button>
        </form>
      </div>
    </div>
  </section>
</div>

<ng-template #thankYouModal let-modal>
  <div class="contact-modal-content">
    <div class="contact-modal-header">
      <button type="button" class="contact-modal-close" aria-label="Cerrar" (click)="modal.dismiss()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="contact-modal-body">
      <div class="contact-modal-icon"><i class="bi bi-check-circle-fill"></i></div>
      <h4 class="contact-modal-title">¡Gracias por escribirnos!</h4>
      <p class="contact-modal-text">Hemos recibido tu mensaje. Te contactaremos pronto.</p>
    </div>
    <div class="contact-modal-footer">
      <button type="button" class="contact-submit-btn contact-modal-btn" (click)="modal.close()">
        <span>Entendido</span>
      </button>
    </div>
  </div>
</ng-template>
